import { doorClient, ImResponse, resolve } from 'services/api';

/**
 * SPU_NAME = 1; SPU_ID = 2; SELLER_SPU = 3; SELLER_SKU = 4;
 */
export type KeywordType = 1 | 2 | 3 | 4;

export interface ItemListParams {
  externalType: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
  externalStoreId: string[];
  keywordType?: KeywordType;
  keyword?: string;
  spuId?: string[];
  pageNo: number;
  pageSize: number;
}

export interface ItemListResponse {
  pageInfo: {
    pageNo: number;
    pageSize: number;
    totalCount: number;
  };
  itemList: Aide.Item[];
}

export function itemList(params: ItemListParams) {
  return resolve(
    doorClient.post<ImResponse<ItemListResponse>>('/oversea-item/v1/item/searchV3', params),
  );
}
